"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impression = void 0;
const utils_1 = require("../utils");
const impression = ({ trackingService, componentNameWithSpaces, componentNameWithDashes, defaultComponentAdditions, ref, }) => (customEvent = {}) => {
    if (!trackingService) {
        return;
    }
    if (ref.current) {
        const defaultImpressionEvent = {
            event: {
                attributes: {
                    componentName: componentNameWithDashes,
                    elementName: '',
                    label: '',
                    clickID: '',
                    pos: '',
                    targetURL: '',
                    value: '',
                    relatedElements: [],
                },
                eventInfo: {
                    eventAction: 'impression',
                    eventName: `${componentNameWithSpaces} - impression`,
                },
            },
            componentUpdate: defaultComponentAdditions,
        };
        const mergedEvent = (0, utils_1.mergeHandler)(defaultImpressionEvent, customEvent, {
            merge: 'deep',
            arrayBehavior: 'replace',
        });
        trackingService.registerImpressionTracking(ref.current, () => mergedEvent);
    }
    else {
        throw new Error('No DOM element found for impression tracking');
    }
};
exports.impression = impression;
//# sourceMappingURL=register-impression.js.map